module.exports = __webpack_public_path__ + "static/media/logofull@2x.b586993c.png";